<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // this.$router.replace('/');
    // var type = navigatoName;

    // if (this._isMobile()) {
    //   // alert("手机端");
    //   this.$router.replace('/home_m');
    // } else {
    //   // alert("pc端");
    //   this.$router.replace('/');
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>

<style>
  @import "./assets/css/font.css";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    /*color: #2c3e50;*/
    /*margin-top: 60px;*/
  }
  *{margin: 0;padding: 0;}
  li{list-style: none;}
  .contentW{min-width: 1300px;width: 75%;height: auto;margin: auto;position: relative;}

  /*底部*/
  .footer{width: 100%;height: 115px;padding-top:50px;font-size: 1.125rem; background-color: #000000;position: relative;font-family: Helvetica;text-align: center;color: #707070;}
  .footer .goTopBtn{position: absolute;right: 0;top: -5rem;width: 4rem;height: 4.1rem;cursor: pointer;background-color: #f05423;display: flex;align-items: center;}
  .footer .goTopBtn>img{width: 1rem;align-items: center;margin: auto;}
  .footer .goTopBtn:hover{background-color: #e04615;}

  .footer_m{width: 100%;height: 2rem;position: relative;background-color: #000000;padding: 2rem 0;}
  .footer_m .footer_mText{width: 70%;margin: auto;line-height: 1rem;font-size: 0.7rem;color: #707070;text-align: center;font-family: Helvetica; }
  .footer_m .goTopBtn{position: absolute;right: 1rem;top: -1.2rem;width: 2.5rem;height: 2.5rem;cursor: pointer;background-color: #f05423;display: flex;align-items: center;}
  .footer_m .goTopBtn>img{width: 1rem;align-items: center;margin: auto;}
  .footer_m .goTopBtn:hover{background-color: #e04615;}

  /*移动端首页轮播分页器*/
  .index05 .swiper-container .swiper-pagination-bullet{width: 13px;height: 13px;}
  .index05 .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin: 0 10px;}
  .instoreContent .swiper-button-next{width: 13px;height: 30px;background-size: 13px 30px; margin-top: 4px;}
  .instoreContent .swiper-button-prev{width: 13px;height: 30px;background-size: 13px 30px; margin-top: 4px;}


</style>
